import React, {Component, Fragment} from "react";
import SimpleInput from "../../../../modules/SimpleInput";

class OnSamsatHeaderInputModifying extends Component {
    render() {
        return (
            <Fragment>
                <div style={{marginBottom: "50px"}}>
                    <div className="grid grid-2x gap-20px grid-mobile-none">
                        <div id="grid-1">
                            <SimpleInput
                                id="input_text_sales_invoice_date"
                                name="salesFakturDate"
                                label="Tanggal Faktur Jual"
                                readOnly
                                value={this.props.dataDetail.salesFakturDate}
                            />
                            <SimpleInput
                                id="input_text_sales_invoice_number"
                                name="salesFakturNo"
                                label="No. Faktur Jual"
                                readOnly
                                value={this.props.dataDetail.salesFakturNo}
                            />
                            <SimpleInput
                                id="input_text_book_number"
                                name="bookNo"
                                label="No. Buku"
                                readOnly
                                value={this.props.dataDetail.bookNo}
                            />
                            <SimpleInput
                                id="input_text_submission_date"
                                name="submissionDate"
                                label="Tanggal Pengajuan"
                                readOnly
                                value={this.props.dataDetail.submissionDate}
                            />
                            <SimpleInput
                                id="input_text_varian_name"
                                name="namaVariant"
                                label="Nama Varian"
                                readOnly
                                value={this.props.dataDetail.variantDTO?.namaVariant}
                            />
                        </div>
                        <div id="grid-2">
                            <SimpleInput
                                id="input_text_warna_name"
                                name="namaWarna"
                                label="Nama Warna"
                                readOnly
                                value={this.props.dataDetail.warnaDTO?.namaWarnaKomersil}
                            />
                            <SimpleInput
                                id="input_text_stnk_name"
                                name="stnkName"
                                label="Nama STNK"
                                readOnly
                                value={this.props.dataDetail.stnkName}
                            />
                            <SimpleInput
                                id="input_text_buyer_name"
                                name="customerName"
                                label="Nama Pembeli"
                                readOnly
                                value={this.props.dataDetail.customerName}
                            />
                            <SimpleInput
                                id="input_text_frame_number"
                                name="frameNumber"
                                label="Nomor Rangka"
                                readOnly
                                value={this.props.dataDetail.frameNumber}
                            />
                            <SimpleInput
                                id="input_text_engine_number"
                                name="engineNumber"
                                label="Nomor Mesin"
                                readOnly
                                value={this.props.dataDetail.engineNumber}
                            />
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default OnSamsatHeaderInputModifying;